module.exports = __webpack_public_path__ + "img/3.c50f97f0.svg";